function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import _ from 'underscore';
import URI from 'urijs';
var JOB_EVENT_MAP = {
  created: 'create',
  queued: 'queue',
  working: 'inprogress',
  completed: 'complete',
  failed: 'fail'
};

function check(delay) {
  var _this = this;

  if (delay == null) {
    delay = this.pollingInterval * 1000;
  }

  var fetch = function fetch() {
    if (_this.isPolling) {
      return _this.fetch().done(function () {
        return check.call(_this);
      }).fail(function (xhr) {
        resetTimeout.call(_this);
        return _this.trigger('error', _this, xhr);
      });
    } else {
      return resetTimeout.call(_this);
    }
  };

  if (delay > 0) {
    this.timeoutId = setTimeout(fetch.bind(this), delay);
  } else {
    return fetch.call(this);
  }
}

function handleStatusChange() {
  var status = this.get('status');
  var eventName = JOB_EVENT_MAP[status];

  switch (status) {
    case 'completed':
    case 'failed':
      this.stopChecking();
      this.trigger(eventName, this.get('data'));
      break;

    default:
      this.trigger(eventName, this);
  }
}

function resetTimeout() {
  clearTimeout(this.timeoutId);
  return delete this.timeoutId;
}
/*
 * Job models for /api/jobs
 *
 * @namespace Model
 *
 * @event create Job created
 *
 * @event queue Job queued
 *
 * @event inprogress Job in progress
 *
 * @event complete Job complete
 *   @param [Object] data Data returned from job
 *
 * @event fail Job failed due to error
 *   @param [Object] data Data returned from job
 *
 * @event error Error fetching job status
 *   @param [XHR] xhr XHR Request
 *
 */


var Job = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(Job, _Backbone$Model);

  function Job() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = Job.prototype;
  /*
   * @param [Object] options
   * @param options [Number] pollingInterval - Set polling interval in seconds
   * @return [Object] The job instance
   *
   */

  _proto.initialize = function initialize(options) {
    var _this2 = this;

    if (options === void 0) {
      options = {};
    }

    _.defaults(options, {
      pollingInterval: 5
    });

    var interval = parseInt(options.pollingInterval);

    if (isNaN(interval)) {
      throw new Error('`options.pollingInterval` must be a number.');
    } else {
      this.pollingInterval = interval;
    }

    this.stopChecking();
    this.promise = new Promise(function (resolve, reject) {
      _this2.on('complete', resolve);

      _this2.on('fail', reject);
    });
    this.on('change:status', handleStatusChange.bind(this));
  }
  /*
   * @return [String]
   *
   */
  ;

  _proto.status = function status() {
    return this.get('status');
  }
  /*
   * @return [Object] The job instance
   *
   */
  ;

  _proto.startChecking = function startChecking() {
    this.isPolling = true;

    if (!this.timeoutId) {
      check.call(this, 0);
    }

    return this;
  }
  /*
   * @return [Object] The job instance
   *
   */
  ;

  _proto.stopChecking = function stopChecking() {
    this.isPolling = false;
    return this;
  }
  /*
   * Make a job and start checking the progress
   * @param [Object] data Attributes to create the job with
   * @param [String] url Url endpoint to create the job
   *
   * @return [Job] The job instance
   */
  ;

  Job.create = function create(url, data) {
    var job = new Job();
    job.save(data, {
      url: url
    }).then(function (data) {
      job.set({
        uuid: URI(data.job_url).segment(-1)
      });
      job.pollingInterval = 1;
      job.startChecking();
    })["catch"](function (xhr, status, error) {
      job.trigger('fail', error);
    });
    return job;
  };

  _createClass(Job, [{
    key: "urlRoot",
    get: function get() {
      return '/api/jobs';
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        status: 'pending'
      };
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return 'uuid';
    }
  }]);

  return Job;
}(Backbone.Model);

export { Job as default };